module.exports = __webpack_public_path__ + "static/media/niatv_icon.70fa5325.svg";